import { render, staticRenderFns } from "./ProuniEnrollmentLinkGate.vue?vue&type=template&id=3f775bee&scoped=true&"
import script from "./ProuniEnrollmentLinkGate.vue?vue&type=script&lang=ts&"
export * from "./ProuniEnrollmentLinkGate.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniEnrollmentLinkGate.vue?vue&type=style&index=0&id=3f775bee&scoped=true&lang=scss&"
import style1 from "./ProuniEnrollmentLinkGate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f775bee",
  null
  
)

export default component.exports